import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Input,
  notification,
  Row,
  Select,
  Table
} from 'antd'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { formItemLayout } from '../../components/_utils/appUtils'
import { updateAbstractFxn } from './actions/index'

const EditAbstractSubmission = props => {
  const {
    form: { getFieldDecorator, setFieldsValue },
    visible,
    onClose,
    article,
    reload
  } = props

  const dispatch = useDispatch()

  const initialAuthorState = {
    author: {},
    coAuthors: []
  }

  const [authorData, setAuthorData] = useState(initialAuthorState)

  const updateAuthor = data => {
    setAuthorData(prev => ({
      ...prev,
      author: {
        ...prev.author,
        ...data
      }
    }))
  }

  const updateCoAuthor = (data, index) => {
    let clone = [...authorData.coAuthors]

    if (clone[index]) {
      clone[index] = {
        ...clone[index],
        ...data
      }
    }

    setAuthorData(prev => ({
      ...prev,
      coAuthors: clone
    }))
  }

  const setFormData = () => {
    if (!article) return

    setFieldsValue({
      titleOfAbstract: article.titleOfAbstract,
      country: article.country,
      issueType: article.issueType,
      researchArea: article.researchArea,
      speakerNote: article.speakerNote,
      abstract: article.abstract,
      keywords: article.keywords ? article.keywords.join(', ') : '',
      journals: article.journals ? article.journals.join(', ') : ''
    })

    let author = {}
    let coAuthors = []

    if (article.authorName) {
      author = {
        name: article.authorName || '',
        email: article.email || '',
        instituteAffiliated: article.institution || '',
        designation: article.designation || '',
        country: article.country || '',
        orcidId: article.orcidId || ''
      }
    }

    coAuthors = article.coAuthors.map(co => ({
      name: co.name || '',
      email: co.email || '',
      instituteAffiliated: co.affiliation || co.instituteAffiliated || '',
      country: co.country || '',
      orcidId: co.orcidId || ''
    }))
    setAuthorData({
      author,
      coAuthors
    })
  }
  useEffect(() => {
    if (visible && article && article._id) {
      setTimeout(() => {
        setFormData()
      }, 0)
    }
  }, [visible, article && article._id])

  const handleSubmit = e => {
    e.preventDefault()

    const { form } = props

    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        notification.error({
          message: 'Required',
          description: 'Fill all required fields.'
        })
        return
      }

      values.abstractId = article._id
      values.author = authorData.author
      values.coAuthors = authorData.coAuthors

      if (values.keywords) {
        values.keywords = values.keywords
          .split(',')
          .map(x => x.trim())
          .filter(Boolean)
      }

      let { success, message } = await dispatch(updateAbstractFxn(values))

      if (success) {
        notification.success({
          message: message || 'Updated successfully'
        })

        reload && reload()
        onClose && onClose()
      } else {
        notification.error({
          message: message || 'Update failed'
        })
      }
    })
  }

  return (
    <Drawer
      title="Edit Abstract Submission"
      width="86%"
      placement="right"
      visible={visible}
      onClose={onClose}
      destroyOnClose
    >
      <Card>
        <Form onSubmit={handleSubmit} className="inputForm">
          <Row gutter={16}>

            {/* BASIC FIELDS */}
            <Col span={24}>
              <GetEachFormFields
                getFieldDecorator={getFieldDecorator}
                item={{
                  label: 'Abstract Title',
                  key: 'titleOfAbstract',
                  type: 'text',
                  required: true
                }}
                formItemLayout={formItemLayout}
              />
            </Col>

            <Col span={12}>
              <GetEachFormFields
                getFieldDecorator={getFieldDecorator}
                item={{ label: 'Issue Type', key: 'issueType', type: 'text' }}
                formItemLayout={formItemLayout}
              />
            </Col>

            <Col span={12}>
              <GetEachFormFields
                getFieldDecorator={getFieldDecorator}
                item={{ label: 'Research Area', key: 'researchArea', type: 'text' }}
                formItemLayout={formItemLayout}
              />
            </Col>

            <Col span={24}>
              <GetEachFormFields
                getFieldDecorator={getFieldDecorator}
                item={{
                  label: 'Speaker Note',
                  key: 'speakerNote',
                  type: 'textArea'
                }}
                formItemLayout={formItemLayout}
              />
            </Col>

            {/* AUTHOR SECTION */}
            <Col span={24}>
              <Card title="Author" style={{ marginBottom: '24px' }}>

                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item label="Name">
                      <Input
                        value={authorData.author.name}
                        onChange={e =>
                          updateAuthor({ name: e.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Email">
                      <Input
                        value={authorData.author.email}
                        onChange={e =>
                          updateAuthor({ email: e.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Institute">
                      <Input
                        value={authorData.author.instituteAffiliated}
                        onChange={e =>
                          updateAuthor({
                            instituteAffiliated: e.target.value
                          })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item label="Designation">
                      <Input
                        value={authorData.author.designation}
                        onChange={e =>
                          updateAuthor({ designation: e.target.value })
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>

              </Card>
            </Col>

            {/* CO AUTHORS */}
            {authorData.coAuthors.length > 0 && (
              <Col span={24}>
                <Card title="Co Authors">

                  {authorData.coAuthors.map((item, index) => (
                    <Row gutter={16} key={index} style={{ marginBottom: 10 }}>

                      <Col span={6}>
                        <Form.Item label="Name">
                          <Input
                            value={item.name}
                            onChange={e =>
                              updateCoAuthor({ name: e.target.value }, index)
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item label="Email">
                          <Input
                            value={item.email}
                            onChange={e =>
                              updateCoAuthor({ email: e.target.value }, index)
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item label="Institute Affiliated">
                          <Input
                            value={item.instituteAffiliated}
                            onChange={e =>
                              updateCoAuthor(
                                { instituteAffiliated: e.target.value },
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item label="Designation">
                          <Input
                            value={item.designation}
                            onChange={e =>
                              updateCoAuthor(
                                { designation: e.target.value },
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </Col>

                    </Row>
                  ))}

                </Card>
              </Col>
            )}

            {/* SUBMIT */}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(EditAbstractSubmission)